import {
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    AfterViewInit,
    Renderer2
  } from '@angular/core';

  @Directive({
    selector: '[ssClickOutsideMenu]'
  })
  export class ClickOutsideMenuDirective implements AfterViewInit, OnDestroy {
    @Input('ssClickOutsideMenu') menuRef: any;

    private removeClickListener?: () => void;
    private removeScrollListener?: () => void;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
      this.removeClickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
        this.onDocumentEvent(event);
      });

      this.removeScrollListener = this.renderer.listen('window', 'scroll', () => {
        this.menuRef?.hide?.();
      });
    }

    ngOnDestroy() {
      this.removeClickListener?.();
      this.removeScrollListener?.();
    }

    private onDocumentEvent(event: Event) {
      const target = event.target as HTMLElement;
      const clickedInside = this.el.nativeElement.contains(target);
      // Exclui os botões que abrem os popups (menu de 3 pontos e pill de
      // status) — clicar neles já chama toggle() diretamente, então não deve
      // contar como "clique fora" (ver [[feature_rights_request_mentions]]).
      const clickedOnButton = target.closest('.ss-menu-btn, .ss-status-pill');

      if (!clickedInside && !clickedOnButton) {
        this.menuRef?.hide?.();
      }
    }
  }
  